<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-15 16:26:46
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:15:22
 * @name: 主页-头部
 * @Description: 主页-头部
 * @FilePath: \project\src\components\index\index-head.vue
 * @Author: desktop
-->
<template>
  <div class="indexHead">
    <div class="bread">
      <template v-for="(item, index) of bread">
        <div class="bread-item" :key="item.name">
          <font @click="index < bread.length - 1 && breakClickHandler(item)">{{
            item.meta.title
          }}</font>
        </div>
      </template>
    </div>
    <el-dropdown trigger="click">
      <span class="el-dropdown-link userInfoText">
        {{ userInfoText }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { debounceation } from '@/utils/decorator';
export default {
  name: "indexHead",
  props: {
    indexView: {
      type: Object,
    },
  },
  computed: {
    bread() {
      return this.indexView.bread.filter((x) => x.meta?.title);
    },
    userInfoText() {
      return (
        (this.$store.state.user?.userInfo?.parent_name ?? "") +
        " " +
        (this.$store.state.user?.userInfo?.realname ?? "")
      );
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击退出
     */
    @debounceation(300)
    logout() {
      this.indexView.logout();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击面包屑
     * @param {Object} item 点击项
     */
    @debounceation(300)
    breakClickHandler(item) {
      this.$router.push(item.path).catch((err) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.indexHead {
  width: 100%;
  height: 50px;
  flex-shrink: 0;
  border-bottom: 1px solid $Vars-border-first-color;
  box-sizing: border-box;
  padding: 0 30px;
  @extend .et-flex-spacebetween;
  .bread {
    flex: 1;
    font-size: $Vars-font-secondary-size;
    @extend .et-flex-start;
    .bread-item {
      @extend .et-flex-start;
      &:last-child {
        color: $Vars-font-important-color;
      }
      &:not(:last-child) {
        font {
          color: $Vars-font-secondary-color;
          @extend .et-clickElement;
          &:hover {
            color: $Vars-normal-color;
          }
        }
      }
      &:not(:last-child)::after {
        content: "";
        width: 5px;
        height: 1px;
        background: $Vars-font-secondary-color;
        margin: 0 4px;
      }
    }
  }
  .userInfoText {
    font-size: $Vars-font-secondary-size;
    @extend .et-clickElement;
  }
}
</style>